/**
 * Liga o estado do assistente à SESSÃO (CERES-IA-002).
 *
 * O isolamento por pessoa e organização (U2) precisava saber quem está na
 * sessão, e o provedor do assistente chamava o hook da sessão dentro de um
 * `try` — com a regra dos hooks desligada — para sobreviver às telas e aos
 * testes montados sem `SessionProvider`. A composição resolve isso sem exceção:
 * este componente vive DENTRO dos dois provedores e informa a identidade; onde
 * não há sessão, ele simplesmente não é montado.
 */

import { useEffect } from 'react';
import { useAssistente } from '../lib/assistente';
import { useSession } from '../lib/session';

export function SincronizarAssistente(): null {
  const { user } = useSession();
  const { sincronizarIdentidade } = useAssistente();
  const identidade = user === null ? null : `${user.id}:${user.organizationId}`;

  useEffect(() => {
    sincronizarIdentidade(identidade);
  }, [identidade, sincronizarIdentidade]);

  return null;
}
